import { jsPDF } from 'jspdf'

// const checkDimentions = (width, height, a4Width = 210, a4Height = 297) => {
//   const aspectRatio = width / height
//   const maxWidth = a4Width
//   const maxHeight = maxWidth / aspectRatio
//   return maxWidth <= a4Width && maxHeight <= a4Height
// }

export function convertTo12HourFormat(timeString) {
  if (!timeString) return '--'

  const [hours, minutes] = timeString.split(':')
  let period = 'AM'

  let formattedHours = parseInt(hours, 10)

  if (formattedHours >= 12) {
    period = 'PM'
    formattedHours = formattedHours > 12 ? formattedHours - 12 : formattedHours
  }

  formattedHours = formattedHours === 0 ? 12 : formattedHours

  return `${formattedHours}:${minutes} ${period}`
}

export function base64ToImageDownload(base64_data, name) {
  const base64Image = base64_data.split(';base64,').pop()
  const blob = new Blob([Uint8Array.from(atob(base64Image), (c) => c.charCodeAt(0))], { type: 'image/png' })

  const downloadLink = document.createElement('a')
  downloadLink.href = URL.createObjectURL(blob)
  downloadLink.download = name + '.png'
  downloadLink.click()

  URL.revokeObjectURL(downloadLink.href)
}

export function base64ToPdfDownload(base64_data, name) {
  const base64Image = base64_data.split(';base64,').pop()
  const blob = new Blob([Uint8Array.from(atob(base64Image), (c) => c.charCodeAt(0))], { type: 'image/png' })

  const pdf = new jsPDF()
  const blobUrl = URL.createObjectURL(blob)

  const img = new Image()
  img.src = blobUrl

  img.onload = () => {
    // Get the aspect ratio and dimensions for centering
    const a4Width = 210
    const a4Height = 297

    const imgWidth = img.width
    const imgHeight = img.height

    // Calculate the aspect ratio of the image
    const aspectRatio = imgWidth / imgHeight
    let renderWidth, renderHeight

    // Adjust the image size to fit the page while maintaining aspect ratio
    if (aspectRatio > 1) {
      renderWidth = a4Width // Fit width
      renderHeight = renderWidth / aspectRatio // Adjust height based on aspect ratio
    } else {
      renderHeight = a4Height // Fit height
      renderWidth = renderHeight * aspectRatio // Adjust width based on aspect ratio
    }

    // Calculate X and Y to center the image
    const x = (a4Width - renderWidth) / 2
    const y = (a4Height - renderHeight) / 2

    // Add image to PDF, centered on the page
    pdf.addImage(img, 'PNG', x, y, renderWidth, renderHeight)
    pdf.save(name + '.pdf')

    // Clean up
    URL.revokeObjectURL(blobUrl)
  }
}
